const PLAYLIST_TYPE = Object.freeze({
  MAIN: 'main',
  ADDITIONAL: 'additional'
});

export default PLAYLIST_TYPE;